

import { createSlice } from '@reduxjs/toolkit';

export const RoleSlice = createSlice({
    name: 'role',
    initialState: {
        loading: false,
        data: {

        },
        main_data: [],
        error: false,
    },
    reducers: {
        ROLE_FETCH_START: (state) => {
            state.loading = true
        },
        ROLE_FETCH_SUCCESS: (state, action) => {
            state.loading = false
            state.data = action.payload
            state.main_data = action.payload.data
        },
        ADD_ROLE_SUCCESS: (state, action) => {
            state.loading = false
            const newArray = state.main_data.filter(todo => todo.site_id !==action.payload.site_id)
             state.main_data = [...newArray,action.payload]
        },
        EDIT_ROLE_FETCH_SUCCESS: (state, action) => {
            state.loading = false
            const newArray = state.main_data.filter(todo => todo.id !== action.payload.id)
            state.main_data = [...newArray, action.payload]
        },
        ROLE_FETCH_ERROR: (state) => {
            state.error = true
        }
    }
});

export const {EDIT_ROLE_FETCH_SUCCESS,ADD_ROLE_SUCCESS, ROLE_FETCH_START, ROLE_FETCH_SUCCESS, ROLE_FETCH_ERROR } = RoleSlice.actions;
export default RoleSlice.reducer;